function columns(translator) {
  return [
    {
      key: 'title',
      name: translator('pages.adminInvitationGroups.list.title'),
      ariaLabel: translator('pages.adminInvitationGroups.list.title'),
      fieldName: 'title',
      data: 'string',
      isPadded: true,
      isResizable: false,
      minWidth: 350,
    },
  ];
}

export { columns };
